import styled from "styled-components";

const ImageContainer = styled.div`
  position: relative;
  text-align: center;
`;
export default ImageContainer;
